export default "__VITE_ASSET__96b77521__"